import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './CompaniasData.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import NewCompany from '../NewCompany/NewCompany';
export default function CompaniasData() {
    const [companies, setCompanies] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [newName, setNewName] = useState('');
    const [company, setCompany] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');

    useEffect(() => {
        fetchCompany();
    }, []);

    const fetchCompany = () => {
        fetch(`${baseURL}/companiesGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCompanies(data.companies || []);
                console.log(data.companies)
            })
            .catch(error => console.error('Error al cargar companias:', error));
    };

    const eliminarCompania = (idCompany) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/companyDelete.php?idCompany=${idCompany}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire(
                                'Error!',
                                data.error,
                                'error'
                            );
                        } else {
                            Swal.fire(
                                '¡Eliminado!',
                                data.mensaje,
                                'success'
                            );
                            fetchCompany();
                        }
                    })
                    .catch(error => {
                        console.error('Error al eliminar compania:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setCompany(item);
        setNewName(item.name);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = (idCompany) => {
        const payload = {
            name: newName !== '' ? newName : company.name
        };

        fetch(`${baseURL}/companyPut.php?idCompany=${idCompany}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    fetchCompany();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };
    return (
        <div>
            <ToastContainer />
            <NewCompany />
            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        type="text"
                                        placeholder='Nombre'
                                        value={newName !== '' ? newName : company.name}
                                        onChange={(e) => setNewName(e.target.value)}
                                    />
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={() => handleUpdateText(company.idCompany)} >Guardar </button>
                        </div>
                    </div>
                </div>
            )}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Compania</th>
                            <th>Nombre</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {companies.map(item => (
                            <tr key={item.idCompany}>
                                <td>{item.idCompany}</td>
                                <td>{item.name}</td>
                                <td>
                                    <button className='eliminar' onClick={() => eliminarCompania(item.idCompany)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
